// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tokens-container[data-v-7a5ef906] {\n  height: 90%;\n  max-height: 300px;\n  overflow-x: scroll;\n}\n.disabled[data-v-7a5ef906] {\n  opacity: 0.7;\n  cursor: default;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
